import { takeLatest, call, put, select, takeEvery } from 'redux-saga/effects'
import * as actions from './actions'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import axios from 'axios'
import { getSagasMsgs } from '../root/selectors'
import qs from 'qs'
import { DEFAUL_DEVICES_TAKE } from './constants'
import { prepareReportsFiltersAsParams } from 'web/src/utils'

export const watchDevicesSaga = [
    takeLatest(actions.DEVICES_REQUEST, requestDevices),
    takeLatest(actions.DEVICE_REQUEST, requestDevice),
    takeLatest(actions.SHARED_USERS_REQUEST, requestSharedUsers),
    takeLatest(actions.SHARE_DEVICES_REQUEST, shareDevices),
    takeLatest(actions.DEVICE_REPORTS_REQUEST, requestDeviceReports),
    takeLatest(actions.RESET_DEVICE_REQUEST, resetDevice),
    takeLatest(actions.REPORT_CATCH_REQUEST, reportCatch),
    takeLatest(actions.SET_OFFLINE_REQUEST, setOffline),
    takeLatest(actions.UPDATE_DEVICE_REQUEST, updateDevice),
    takeLatest(actions.BATTERY_RESET_REQUEST, batteryReset),
    takeLatest(actions.FETCH_MORE_DEVICES, requestMoreDevices),
    takeLatest(actions.SET_STATUS_ACTIVE_TOM_REQUEST, setStatusActiveTOM),
    takeLatest(actions.POST_NEW_DEVICE_IMAGES, postDeviceImagesSaga),
    takeLatest(actions.DELETE_DEVICE_IMAGES, deleteDeviceImagesSaga),
    takeLatest(actions.SET_MAINTENANCE_MODE, setMaintenanceModeSaga),
    takeEvery(actions.GET_IMAGES_BY_DEVICE_ID, getImagesByDeviceIdSaga)
]
const getSkip = state => state.devices.skip
function* requestDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(fetchDevices, {
            ...action.filters,
            skip: 0,
            take: DEFAUL_DEVICES_TAKE
        })
        yield put(actions.devicesRequestSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.devicesRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function fetchDevices(params) {
    const response = await axios.get(`${process.env.API_URL}/devices`, {
        params,
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    })
    return response.data
}

function* requestDevice(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.deviceRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function fetchDevice(deviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/devices/${deviceId}`
    )
    return response.data
}

function* requestDeviceReports(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            fetchDeviceReports,
            action.deviceId,
            action.filters
        )
        yield put(stopLoading())
        yield put(actions.deviceReportsSuccess(response))
    } catch (ex) {
        yield put(actions.deviceReportsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDeviceReportsEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function fetchDeviceReports(deviceId, filters) {
    const filtersToParams = prepareReportsFiltersAsParams(filters)
    const response = await axios.get(`${process.env.API_URL}/reports`, {
        params: {
            ...filtersToParams,
            deviceId: Number(deviceId)
        },
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    })
    return response.data
}

function* requestSharedUsers() {
    try {
        const response = yield call(fetchSharedUsers)
        yield put(actions.sharedUsersRequestSuccess(response))
    } catch (ex) {
        yield put(actions.sharedUsersRequestError())
    }
}

async function fetchSharedUsers() {
    const response = await axios.get(`${process.env.API_URL}/users/shared`)
    return response.data
}

function* shareDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        /* const response =  */ yield call(shareDevicesRequest, action.devices)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.shareDevicesRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.shareDevicesSuccess())
        yield put(actions.devicesRequest())
    } catch (ex) {
        yield put(actions.shareDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.shareDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function shareDevicesRequest(devices) {
    const response = await axios.post(
        `${process.env.API_URL}/devices/share`,
        devices
    )
    return response.data
}

function* resetDevice(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(resetDeviceRequest, action.deviceId)
        yield put(actions.resetDeviceSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.resetDeviceRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.deviceReportsRequest(action.deviceId, action.filters))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.resetDeviceError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.resetDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function resetDeviceRequest(deviceId) {
    await axios.patch(`${process.env.API_URL}/devices/hard-reset/${deviceId}`)
}

function* reportCatch(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(
            reportCatchRequest,
            action.deviceId,
            action.catchDescription,
            action.created_at
        )
        yield put(actions.reportCatchSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.reportCatchRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.deviceReportsRequest(action.deviceId, action.filters))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.reportCatchError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.reportCatchEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function reportCatchRequest(deviceId, catchDescription, created_at) {
    await axios.patch(
        `${process.env.API_URL}/devices/report-catch/${deviceId}`,
        {
            catch_description: catchDescription,
            created_at
        }
    )
}

function* setOffline(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(setOfflineRequest, action.deviceId)
        yield put(actions.setOfflineSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.setOfflineRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.deviceReportsRequest(action.deviceId, action.filters))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.setOfflineError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.setOfflineEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function setOfflineRequest(deviceId) {
    await axios.patch(`${process.env.API_URL}/devices/set-offline/${deviceId}`)
}

function* batteryReset(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(batteryResetRequest, action.deviceId)
        yield put(actions.batteryResetSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.batteryResetRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.batteryResetError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.batteryResetEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function batteryResetRequest(deviceId) {
    await axios.patch(
        `${process.env.API_URL}/devices/reset-battery/${deviceId}`
    )
}

function* updateDevice(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(updateDeviceRequest, action.deviceId, action.body)
        yield put(actions.updateDeviceSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateDeviceRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.updateDeviceError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function updateDeviceRequest(deviceId, body) {
    await axios.patch(`${process.env.API_URL}/devices/${deviceId}`, body)
}

function* setStatusActiveTOM(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(setStatusActiveTOMRequest, action.deviceId)
        yield put(actions.setStatusActiveTOMSuccess())
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.tomStatusResetRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.batteryResetError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.tomStatusResetEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function setStatusActiveTOMRequest(deviceId) {
    await axios.patch(
        `${process.env.API_URL}/devices/set-status-active-tom/${deviceId}`
    )
}

function* requestMoreDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    const { filters } = action
    const skip = yield select(getSkip)

    try {
        const response = yield call(fetchDevices, {
            ...filters,
            skip: skip || DEFAUL_DEVICES_TAKE,
            take: DEFAUL_DEVICES_TAKE
        })
        yield put(actions.devicesRequestMoreSuccess(response))
    } catch (ex) {
        yield put(actions.devicesRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

//

function* postDeviceImagesSaga(action) {
    const sagasMsgs = yield select(getSagasMsgs)

    try {
        yield put(actions.setDeviceImagesLoader('post'))
        yield call(postDeviceRequest, action.deviceParams)
        const response = yield call(
            getImagesByDeviceId,
            action.deviceParams.deviceId
        )

        yield put(
            actions.setImagesForDevices({
                [action.deviceParams.deviceId]: response
            })
        )
        yield put(actions.setDeviceImagesLoader(false))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deviceImagesAddRes,
                options: {
                    variant: 'success'
                }
            })
        )
    } catch (error) {
        yield put(actions.setDeviceImagesLoader(false))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deviceImagesAddEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function postDeviceRequest(action) {
    const formData = new FormData()

    formData.append('deviceId', action.deviceId)
    formData.append('customerId', action.customerId)
    action.images.forEach(image => formData.append(`images`, image))

    const response = await axios.post(
        `${process.env.API_URL}/devices/pictures`,
        formData,
        {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
    )

    return response.data
}

function* getImagesByDeviceIdSaga(action) {
    const sagasMsgs = yield select(getSagasMsgs)

    try {
        yield put(actions.setDeviceImagesLoader('get'))
        const response = yield call(getImagesByDeviceId, action.deviceId)
        yield put(actions.setDeviceImagesLoader(false))
        yield put(
            actions.setImagesForDevices({
                [action.deviceId]: response
            })
        )
    } catch (ex) {
        yield put(actions.setDeviceImagesLoader(false))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDeviceImagesEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getImagesByDeviceId(deviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/devices/${deviceId}/pictures`
    )
    const data = response.data || []
    return data
}

function* deleteDeviceImagesSaga(action) {
    const sagasMsgs = yield select(getSagasMsgs)

    try {
        yield put(actions.setDeviceImagesLoader('edit'))
        yield call(deleteDeviceImagesRequest, action)
        yield put(actions.setDeviceImagesLoader(false))
        const response = yield call(
            getImagesByDeviceId,
            action.deviceParams.deviceId
        )

        yield put(
            actions.setImagesForDevices({
                [action.deviceParams.deviceId]: response
            })
        )
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deviceImagesEditRes,
                options: {
                    variant: 'success'
                }
            })
        )
    } catch (ex) {
        yield put(actions.setDeviceImagesLoader(false))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deviceImagesEditEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function deleteDeviceImagesRequest(action) {
    const formData = new FormData()

    formData.append('deviceId', action.deviceParams.deviceId)
    formData.append('customerId', action.deviceParams.customerId)

    action.deviceParams.deletedPictureKeys?.filter(image => {
        formData.append('deletedPictureKeys[]', image.key)
    })

    action.deviceParams.setDeletedPictureKeys([])

    const response = await axios.patch(
        `${process.env.API_URL}/devices/pictures`,
        formData,
        {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
    )

    action.deviceParams.setDeletingImagesSuccess(true)

    return response.data
}

function* setMaintenanceModeSaga(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(
            setMaintenanceModeRequest,
            action.deviceId,
            action.inMaintenanceMode,
            action.durationMinutes
        )
        const response = yield call(fetchDevice, action.deviceId)
        yield put(actions.deviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateDeviceRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.commonLoadingError,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function setMaintenanceModeRequest(
    deviceId,
    inMaintenanceMode,
    durationMinutes
) {
    await axios.patch(
        `${process.env.API_URL}/devices/${deviceId}/maintenance-mode`,
        {
            maintenance_mode: !inMaintenanceMode,
            ...(!inMaintenanceMode ? { duration_minutes: durationMinutes } : {})
        }
    )
}
